import { StyledAppSwitch } from "./AppSwitch.styles";

export const AppSwitch = (props) => {
  return <StyledAppSwitch {...props} />;
};
